import { FormHelperText } from '@material-ui/core';
import type { CreationForm } from './creationForm';
import { ProviderSelector } from './ProviderSelector';
import { RepoHierarchyPicker } from './RepoHierarchyPicker';
import { IssuePicker } from './IssuePicker';
import { OptionsFeedback } from './OptionsFeedback';
import { useCreationStyles } from './useCreationStyles';

export function CreationProviderPicker({
  providers,
  repository,
  issue,
  content,
  feedback,
}: CreationForm) {
  return (
    <>
      <OptionsFeedback query={providers.query} label="Providers" />
      <ProviderSelector
        providers={providers.query.items}
        value={providers.selected?.id ?? null}
        onChange={next => {
          providers.select(next);
          repository.reset();
          issue.reset();
          content.removeCard();
          feedback.setError(undefined);
        }}
      />
    </>
  );
}

function CreationIssueField({ providers, issue }: CreationForm) {
  const classes = useCreationStyles();
  const provider = providers.selected;
  const { hierarchy } = issue;
  if (!hierarchy.repository || !provider) return null;
  return (
    <div className={classes.wiSection}>
      <IssuePicker
        provider={provider.id}
        scope={{
          owner: hierarchy.owner!.id,
          project: hierarchy.project?.name,
          repo: hierarchy.repository.name,
        }}
        selected={issue.selected}
        onSelect={selected => issue.select(selected, provider)}
      />
    </div>
  );
}

export function CreationProviderFields(form: CreationForm) {
  const { providers, issue, feedback } = form;
  if (!providers.isAgnostic || !providers.selected) return null;
  return (
    <>
      <RepoHierarchyPicker
        provider={providers.selected}
        value={issue.hierarchy}
        onChange={next => {
          issue.changeHierarchy(next);
          feedback.clearFields('owner', 'project', 'repo');
        }}
      />
      {['owner', 'project', 'repo', 'branch'].map(
        field =>
          feedback.fieldErrors[field] && (
            <FormHelperText error key={field}>
              {feedback.fieldErrors[field]}
            </FormHelperText>
          ),
      )}
      <CreationIssueField {...form} />
    </>
  );
}
